module.exports = __webpack_public_path__ + "static/media/logo.d4f95f23.png";